import React from "react";
import { getCdn } from "utils";

const Icon = ({
	ariaHidden = null,
	brand = "",
	cdnUrl = "",
	className = "",
	color = "",
	icon = null,
	loading = "lazy",
	onClick = null,
	role = "menuitem",
	rotate = false,
	title = null,
}) => {
	let iconClass = "syndicated-icon";
	if (icon) iconClass += ` syndicated-icon--${icon}`;
	if (rotate) iconClass += ` syndicated-icon--rotate`;
	if (className) iconClass += ` ${className}`;
	if (brand) iconClass += ` syndicated-icon--${brand}`;
	if (color) iconClass += ` syndicated-icon--no-filter`;

	const iconUrl = `${
		cdnUrl || (getCdn && getCdn(true)) || ""
	}/icons/pep/${icon}${color ? `--${color}` : ""}.svg`;

	if (!icon) {
		return null;
	}

	return (
		<img
			alt={title || ""}
			title={title}
			className={iconClass}
			src={iconUrl}
			loading={loading}
			onClick={onClick}
			aria-hidden={ariaHidden}
			role={role}
		/>
	);
};

export default Icon;
